import { exportRegimeApi } from "../../api";

const ExportRegimeService = {
  fetchDropdown: async (term: string) => {
    const response = await exportRegimeApi.fetchCustom(`/search?term=${term}`);
    return response.data;
  },
};

export default ExportRegimeService;
